import Success from "components/Success";
import React from "react";
import { useNavigate } from "react-router-dom";
import Grid2 from "@mui/material/Unstable_Grid2";
import {
  Box,
  Card,
  Checkbox,
  CircularProgress,
  IconButton,
  Link,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { Search } from "@mui/icons-material";
import { productApi } from "store/api";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode, Navigation, Thumbs, Keyboard, Pagination } from "swiper/modules";
import "swiper/css";

import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
// import IconButton from '@mui/material/IconButton'
import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";

// import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import "../../../ProductDetails/styles.css";
import { addProductBoughtTogetherApi } from "store/api";

const ProductTogetherTab = ({ product, handleClose, getProductDetails }) => {
  const navigate = useNavigate();
  const [success, setSuccess] = React.useState(false);
  const [openSuccess, setOpenSuccess] = React.useState(false);
  const [msg, setMsg] = React.useState(false);
  const [products, setProducts] = React.useState([]);
  const [noData, setNodata] = React.useState(false);
  const [loader, setLoader] = React.useState(false);

  const [selectedProducts, setSelectedProducts] = React.useState([]);

  const handleCloseSuccess = () => {
    setOpenSuccess(false);
  };

  const FetchProduct = async searchTerm => {
    setLoader(true);
    setNodata(false);
    const params = !searchTerm
      ? {}
      : {
          keyword: searchTerm,
        };
    try {
      const response = await productApi(params);
      if (response?.success) {
        setLoader(false);
        const filteredArray = response?.data?.filter(
          item1 =>
            !product?.frequentlyBoughtProduct.some(item2 => item1.productId === item2.productId)
        );
        setProducts(filteredArray);
        if (!response?.data?.length) setNodata(true);
      }
    } catch (err) {
      console.error(err);
    }
  };
  const [debounceTimeout, setDebounceTimeout] = React.useState(null);
  const handleChangeProduct = async e => {
    const { value } = e.target;
    if (debounceTimeout) clearTimeout(debounceTimeout);
    const newTimeout = setTimeout(() => {
      FetchProduct(value);
    }, 500);

    setDebounceTimeout(newTimeout);
  };
  const redirect = data => {
    navigate("/product-details", { state: { productId: data.productId } });
  };
  React.useEffect(() => {
    FetchProduct();
  }, []);

  // Toggle product selection
  const handleToggleSelect = productId => {
    setSelectedProducts(prev =>
      prev.includes(productId) ? prev.filter(id => id !== productId) : [...prev, productId]
    );
  };

  const handleSubmitBT = async () => {
    let data = {
      productId: product?.productId,
      frequentlyBoughtProduct: selectedProducts,
    };
    const response = await addProductBoughtTogetherApi(data);
    if (response?.success) {
      setMsg("Product Added Successfully");
      setSuccess(true);
      getProductDetails();
    } else {
      setSuccess(false);
      setMsg("Something went wrong. Please try again later.");
    }
    setOpenSuccess(true);
    setTimeout(() => {
      handleClose();
    }, 3000);
  };

  // Select or deselect all products
  const handleSelectAll = () => {
    if (selectedProducts.length === products.length) {
      setSelectedProducts([]);
    } else {
      setSelectedProducts(products.map(product => product.productId));
    }
  };

  return (
    <div style={{ padding: "0 20px" }}>
      <AppBar sx={{ position: "relative" }}>
        <Toolbar style={{ justifyContent: "space-between", alignItems: "center", padding: 0 }}>
          <div>Select Bought Together</div>
          <IconButton edge='end' color='inherit' onClick={handleClose} aria-label='close'>
            <CloseIcon />
          </IconButton>
          <Button
            // color='warning'
            variant='contained'
            style={{
              position: "fixed",
              bottom: "20px",
              right: "30px",
              color: "white",
              border: "2px solid black",
              textTransform: "capitalize",
              fontSize: "16px",
              background: "repeating-radial-gradient(black, #000 100px)",
            }}
            onClick={handleSubmitBT}
          >
            Save
          </Button>
        </Toolbar>
      </AppBar>
      {/* Search and Rows Per Page */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          paddingBottom: "10px",
          paddingTop: "10px",
          alignItems: "center",
          gap: "12px",
          borderTop: "1px solid lightgray",
          borderBottom: "1px solid lightgray",
        }}
      >
        <div style={{ borderRadius: "6px", border: "1px solid lightgray", paddingRight: "12px" }}>
          <Checkbox
            checked={selectedProducts.length === products.length && products.length > 0}
            indeterminate={selectedProducts.length > 0 && selectedProducts.length < products.length}
            onChange={handleSelectAll}
          />
          <Typography variant='body2' display='inline'>
            Select All
          </Typography>
        </div>
        <TextField
          placeholder='Search here...'
          InputProps={{
            endAdornment: (
              <IconButton color='inherit'>
                <Search />
              </IconButton>
            ),
          }}
          onChange={e => FetchProduct(e.target.value)}
        />
      </div>
      <Grid2 container py={3} spacing={3}>
        {noData && <div>No Product found</div>}
        {loader && <CircularProgress color='success' />}
        {products?.length > 0 &&
          products?.map(product => (
            <ProductNew
              key={product.productId}
              product={product}
              redirect={data =>
                navigate("/product-details", { state: { productId: data.productId } })
              }
              selected={selectedProducts.includes(product.productId)}
              onSelect={handleToggleSelect}
            />
          ))}
      </Grid2>
      {/* Selected Products Output */}
      {/* <Typography variant='h6' sx={{ marginTop: "20px" }}>
        Selected Product IDs: {JSON.stringify(selectedProducts)}
      </Typography> */}
      <Success open={openSuccess} success={success} msg={msg} handleClose={handleCloseSuccess} />
    </div>
  );
};

export default ProductTogetherTab;
import ImageNotSupportedIcon from "@mui/icons-material/ImageNotSupported";

const ProductNew = ({ product, selected, onSelect }) => {
  const [selectedColor, setSelectedColor] = React.useState(product?.colors[0]?.colorCode || "");
  const currentColorData = product?.colors.find(c => c.colorCode === selectedColor);

  return (
    <Grid2 xs={12} sm={4} md={3} lg={2} style={{ cursor: "pointer" }}>
      <Card style={{ cursor: "pointer", position: "relative" }}>
        <label style={{ cursor: "pointer" }}>
          <Checkbox
            checked={selected}
            onChange={() => onSelect(product.productId)}
            style={{ position: "absolute", top: 5, left: 5, zIndex: 10 }}
          />

          <Swiper
            style={{
              "--swiper-navigation-color": "#fff",
              "--swiper-pagination-color": "#fff",
              // borderRadius: "10px",
              height: "220px",
              position: "relative",
            }}
            loop={true}
            spaceBetween={10}
            pagination={true}
            // thumbs={{ swiper: thumbsSwiper }}
            modules={[FreeMode, Thumbs, Pagination]}
            className='mySwiper2'
          >
            <div
              style={{
                top: 0,
                width: "100%",
                height: "100%",
                zIndex: 0,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                position: "absolute",
                borderRadius: "16px 16px 0 0",
                flexDirection: "column",
                textTransform: "uppercase",
                gap: "16px",
              }}
            >
              <div
                style={{
                  border: "1px solid #636363",
                  backgroundColor: "rgba(170,170,170,0.35)",
                  borderRadius: "50%",
                  height: "40px",
                  width: "40px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#636363",
                }}
              >
                <ImageNotSupportedIcon style={{ fontSize: "40px", fill: "#636363" }} />
              </div>
              <div style={{ fontSize: "10px" }}>Comming Soon</div>
            </div>
            {currentColorData?.images.map((e, i) => (
              <SwiperSlide className='mySwiper5' style={{ position: "relative" }}>
                <img
                  alt='product'
                  src={e.image}
                  style={{
                    top: 0,
                    width: "100%",
                    height: "100%",
                    zIndex: 2,
                    objectFit: "cover",
                    objectPosition: "center",
                    position: "absolute",
                    borderRadius: "16px 16px 0 0",
                  }}
                />
              </SwiperSlide>
            ))}
          </Swiper>

          <Stack spacing={2} sx={{ px: 3, py: 2 }}>
            <Link
              color='inherit'
              underline='hover'
              variant='subtitle2'
              style={{ fontSize: "0.875rem", fontWeight: "500" }}
              noWrap
            >
              {product?.nameEn}
              <br />
              {product?.nameUz}
            </Link>

            <Box display='flex' alignItems='center' justifyContent='space-between'>
              <Box class='MuiBox-root css-udwogp'>
                {product?.colors?.map((e, i) =>
                  e?.isActive ? (
                    <Box
                      className={`MuiBox-root ${
                        i == 0
                          ? "css-1r15jgt"
                          : i == 1
                          ? "css-1ebeuj6"
                          : i == 2
                          ? "css-16couxa"
                          : ""
                      }`}
                      //   onClick={() => handleColorChange(e.colorCode)}
                      style={{ backgroundColor: e.colorCode }}
                    ></Box>
                  ) : (
                    ""
                  )
                )}
              </Box>
              {/* <ColorPreview colors={product.colors} /> */}
              <Typography
                variant='subtitle1'
                style={{
                  fontSize: "0.875rem",
                  fontWeight: "500",
                  alignItems: "center",
                  gap: "6px",
                  display: "flex",
                }}
              >
                <div
                  style={{
                    color: "red",
                    textDecoration: "line-through",
                    fontSize: "10px",
                    opacity: "0.6",
                  }}
                >
                  ₴{product?.price}
                </div>
                ₴{product?.discountPrice}
              </Typography>
            </Box>
          </Stack>
        </label>
      </Card>
    </Grid2>
  );
};
